module.exports = require("././angular-masonry.js");


//////////////////
// WEBPACK FOOTER
// angular-masonry (bower component)
// module id = 1478
// module chunks = 0